import React from 'react';
import {ListVehiclesAndState as ListVehiclesAndStateComponent} from '../components/listvehicles-and-state/index';

const List = ({match}) =>
    <ListVehiclesAndStateComponent listId={match.params.listId}/>;

export default List;

